module.exports = __webpack_public_path__ + "img/headIcon.335f0158.jpg";